const WA_UPLOAD = {
  headers: [
    { text: 'Status', value: 'status', sortable: false },
    { text: 'FileName', value: 'fileName', sortable: false },
    { text: 'Transaction At', value: 'transactionDate', sortable: false },
    { text: 'Uploaded By', value: 'operatedBy', sortable: false },
    { text: 'Download Link', value: 'fileUrl', sortable: false },
    { text: 'Details', value: 'data', sortable: false }
  ],
  itemHeaders: [
    { text: 'Loan #', value: 'loanNo', sortable: false },
    { text: 'Error Message', value: 'errorMessage', sortable: false },
    { text: 'Status', value: 'errorType', sortable: false }
  ]
}
export default WA_UPLOAD
